/**
 * Dates of the Leading Analyzer form (CU-869fmjzrh). Clearing "Booking date range" (the picker's ✕ emits
 * [null, null]) used to copy `getNextDate({ days: 0 }, null)` = Invalid Date into the pick-up range, and
 * `formatDate(Invalid Date)` throws a RangeError (Invalid Date is truthy, so `formatDate`'s empty check misses it).
 * An `sp` without pick-up dates gives the same Invalid Date through `stringToDate(undefined)`.
 *
 * No imports: `node --test` runs it.
 */

const isValidDate = v => v instanceof Date && !Number.isNaN(v.getTime())

/** The pick-up range after the booking range changes: each side with a valid booking date copies it, as before;
 * a side without one (cleared, half-picked) keeps the pick-up it had. */
export function pickupAfterBookingChange(booking, pickup) {
	return [0, 1].map(i => {
		const b = booking?.[i]
		return isValidDate(b) ? new Date(b.getTime()) : pickup?.[i]
	})
}

/** A date for `formatDate`: an Invalid Date counts as empty (null), the same as a cleared field today */
export function validDateOrEmpty(v) {
	return isValidDate(v) ? v : null
}
